import { ROOM_RATE_LPC_TYPE } from '~/consts/ratePlans';

import { RATE_PLAN_ACTIVE_STATUS, RatePlan } from '~/hooks/apis/reservation/usePropertyRatePlans';

/** Cheapest LPC (Luxury Premium Collection) rate for parity card + EmailGenerator. */
export function selectCheapestLPCRatePlan(ratePlans: Array<RatePlan>): RatePlan | undefined {
  const lpcPlans = ratePlans.filter((plan) => plan.product_type === ROOM_RATE_LPC_TYPE);
  if (lpcPlans.length === 0) {
    return undefined;
  }
  const activePlans = lpcPlans.filter((plan) => plan.status?.toLowerCase() === RATE_PLAN_ACTIVE_STATUS);
  const plansWithPrice = activePlans.filter((p) => p.price != null).sort((a, b) => (a.price ?? 0) - (b.price ?? 0));
  return plansWithPrice[0] ?? activePlans[0] ?? lpcPlans[0];
}
